import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_433: DocMigration = {
  maxSchemaVersion: "0.0.433",
  description: "Add missing entityType and sortIndex fields to effect entities migrated in migration 0.0.372",
  apply(json: any) {
    if (!json.effects) {
      return json;
    }

    const effectsArray = Object.values(json.effects) as any[];

    let maxSortIndex = effectsArray.reduce((a, b) => Math.max(a, b.sortIndex ?? a), 0);

    for (const effectId in json.effects) {
      const effect = json.effects[effectId];
      effect.entityType = "EFFECT";
      if (effect.sortIndex === undefined) {
        effect.sortIndex = ++maxSortIndex;
      }
    }

    return json;
  },
};

export default migration_0_0_433;
